import 'jquery';

// Handling usefull functions, beginning with closing
(function ($) {
  'use strict';
  var obj = {};
  // close the iframe
  obj.closeWindow = function () {
    if (parent === window) {
      // no iframe, maybe mobile
      try {
        window.close();
      } catch (e) {
        // console.error(e);
      }
    } else {
      // we're in iframe
      try {
        // Todo: get target domain from checkout config
        // NOSONAR - we cant know the target domain
        parent.postMessage('closeIframe', '*');
      } catch (e) {
        // console.error(e);
      }
    }
  };
  obj.goTo = function (el) {
    var href = el.data('href');
    if (href) {
      location.href = href;
    }
  };

  $('body').on('click', '*[data-click]', function (event) {
    if ('function' === typeof obj[$(this).data('click')]) {
      obj[$(this).data('click')]($(this));
      event.preventDefault();
    }
  });
}(jQuery));

/**
 * The whole iframe magic
 */
(function ($, document, window, JSON) {
  'use strict';

  // If we're not in iframe go out...
  // Todo: debug event-function
  if (window === window.top) {
    return;
  }

  var iFrameName = window.name || '',
    body = $('body'),
    container = document.getElementById('mainContainer') || document.body,
    analyticsContainer = $('#analyticsData'),
    /**
     * since we position things absolute, we cant work with a container height
     * @returns {number}
     */
    getHeight = function () {
      // get all children in our container
      let children = container.childNodes;
      var height = 0;
      //
      // if (container.offsetHeight > 200) {
      //   return container.offsetHeight;
      // }

      // iterate children
      for (let child of children) {
        let childHeight = child.scrollHeight;
        // there are some textnode children
        // at the moment
        if (isNaN(childHeight)) {
          continue;
        }

        // if our element has a height
        height = height + childHeight;
      }

      if (Math.abs(container.scrollHeight - height) > 50) {
        container.style.minHeight = height + 'px';
        // height = container.offsetHeight;
      }

      return container.scrollHeight;
    },
    post = function (func, param) {
      var obj = {
        func: func,
        param: param,
        api: 'plenigo',
        iFrameName: iFrameName,
      };
      // Todo: get target domain from checkout config
      // NOSONAR - we cant know the target domain
      window.parent.postMessage(JSON.stringify(obj), '*');
    },
    close = function () {
      // for older sdks, where we are a popup
      if (window.opener) {
        // Todo: get target domain from checkout config
        // NOSONAR - we cant know the target domain
        window.opener.postMessage('closeIframe', '*');
      }

      post('close', true);
    },
    restart = function () {
      post('restart', true);
    },
    getData = function (key) {
      return document.body.getAttribute('data-' + key);
    },
    hasStatistics = function () {
      return (getData('statistics') === 'true');
    },
    // statistic function
    postAction = function (action, data, el) {
      var forms = (el.is('form') ? el : $('form')),
        formData = [],
        page = document.location.pathname.split('/'),
        product = getData('product') || '';

      forms.each(function () {
        var form = $(this);
        form.find(':input.propagate').each(function () {
          formData.push({
            name: $(this).attr('name'),
            value: $(this).val(),
          });
        });
      });

      post('onAction', {
        data: (formData.length ? formData : data),
        action: action,
        pageName: getData('page'),
        page: page[page.length - 1],
        product: product,
      });
    },

    // iframe control methods
    /**
     * all methods we want to be callable from outside should be properties of iframe object
     * @type {{resize: resize}}
     */
    iframe = {
      /**
       * kindly ask for a new height
       * may start a loop. be carefully!
       */
      resize: function () {
        post('resize', getHeight());
      },
      /**
       * We want to have the back-functionality from outside to allow more seamless
       *
       */
      back: function () {
        location.href = body.data('back');
      },
      /**
       * sets the iframe name
       * @param name
       */
      setName: function (name) {
        window.name = iFrameName = name;
      },
      /**
       * sets outside cookies to inside
       * @param cookies
       */
      setCookies: function (cookies) {
        window.cookies = cookies;
        // tell all we're finished
        body.trigger('plenigo.initialized');
      },
      stripeIdentity: function (result) {
        body.trigger('plenigo.stripeResult', result);
      },
      stripeButtons: function (result) {
        body.trigger('plenigo.stripeButtons', result);
        console.log('stripeButtons', result);
      },
      stripeButtonsSuccess: function (result) {
        body.trigger('plenigo.stripeButtonsSuccess', result);
        console.log('stripeButtonsSuccess', result);
      },
      stripeButtonsCancel: function (result) {
        body.trigger('plenigo.stripeButtonsCancel', result);
        console.log('stripeButtonsCancel', result);
      },
      stripeButtonsError: function (result) {
        body.trigger('plenigo.stripeButtonsError', result);
      },
      googleOneTapResult: function (result) {
        body.trigger('plenigo.googleOneTapResult', result);
      },
      setConfig: function (config) {
        body.trigger('plenigo.setConfig', config);
        console.debug('got config', config);
      },
    },

    // Dispatching functionality
    /**
     * called from outer iframe postMessage Event
     * here we take care of all functionality, we get
     * @param event
     */
    dispatch = function (event) {
      var data = {}, isTrusted = false;

      // we have to check the events origin to prevent side effects with 3rd party scripts
      // we have name of iframe
      // Todo: check the origin
      // return;

      console.debug('dispatch', event.data);

      try {
        data = JSON.parse(event.data);
        if ('object' !== typeof data) {
          return;
        }
      } catch (exception) {
        // console.error(e);
        return;
      }

      if ('plenigo' === data.api && 'function' === typeof iframe[data.func]) {
        // we're confronted with billions of events, here we filter all calls from our iframes child
        isTrusted = (data.iFrameName && data.iFrameName === iFrameName);

        iframe[data.func](data.param || '', isTrusted);
      }
    },
    loadFunction = function () {
      // idea: if iframe is fully loaded, we really know its height
      // thats why we put 200px on top of content height, to get its real inner height
      // post('finishedLoading', getHeight() + 200);
      post('finishedLoading', getHeight());

      window.setTimeout(function () {
        post('resize', getHeight());
      }, 150);

    },
    unloadFunction = function () {
      post('unload', 'started');
    },
    processingFunction = function () {
      post('processing', 'started');
    },
    // vanilla event handling
    eventMethod = (window.addEventListener ? 'addEventListener' : 'attachEvent'),
    eventer = window[eventMethod],
    resizeEvent = (eventMethod === 'attachEvent' ? 'onresize' : 'resize'),
    messageEvent = (eventMethod === 'attachEvent' ? 'onmessage' : 'message');

  //  listen on resize events
  eventer(resizeEvent, function () {
    post('resize', getHeight());
  }, false);

  // calling Dispatcher Method
  eventer(messageEvent, dispatch, false);

  window.onload = loadFunction;
  document.onload = loadFunction;
  window.onunload = unloadFunction;

  // working with statistic data
  if (analyticsContainer.length) {
    try {
      let analyticsData = JSON.parse(analyticsContainer.html() || '{}');
      post('analyticsLoad', analyticsData);
    } catch (e) {
      console.error('Something went wrong during analyzing Analytics data');
    }
  }

  // post a redirect call to our parent
  if (body.data('location')) {
    post('location', body.data('location'));
  }

  // post a redirect call to our parent
  if (body.data('login-success')) {
    post('loginSuccess', body.data('login-success'));
  }

  // post the purchase success message to our parent
  if (body.data('success')) {
    post('purchaseSuccess', body.data('success'));
  }

  // calling ready to get initialized
  post('initialize', 'newCheckout');

  // post 1st resize, knowing, we're not ready yet
  post('resize', getHeight());

  // tell outside world our session
  if (body.data('session-id')) {
    // we prefix sessionID to prevennt overwriting it by snippets
    post('setSession', 'checkout.' + body.data('session-id'));
  }


  body.on('click', '[data-action="restart"]', function (event) {
    restart();
    event.preventDefault();
    // post('restart', '');
  })
    .on('click', '[data-action="purchaseSuccess"]', function (event) {
      post('purchaseSuccess', $(this).data('action-data'));
      event.preventDefault();
      // post('restart', '');
    })
    .on('click', '[data-action="alreadyBought"]', function (event) {
      post('purchaseSuccess', $(this).data('action-data'));
      event.preventDefault();
      // post('restart', '');
    })
    .on('click', '[data-action="purchaseStopped"]', function (event) {
      let data = $(this).data('action-data');
      event.preventDefault();
      post('purchaseFailed', data);
    })
    .on('click', '[data-action="reload"]', function (event) {
      let data = $(this).data('action-data');
      event.preventDefault();
      post('location', data);
    })
    .on('resize plenigo.resize load ready', function (event, data) {
      if (
        typeof data !== 'undefined' &&
        typeof data.scroll !== 'undefined' &&
        data.scroll
      ) {
        post('resizeWithoutScroll', getHeight());
      } else {
        post('resize', getHeight());
      }
    })
    .on('plenigo.initAmazon', function (event, data) {
      post('callAmazonPay', data);
    })
    .on('plenigo.datatransLightbox', function (event, data) {
      post('datatransLightbox', data);
    })
    .on('plenigo.initStripeIdentity', function (event, data) {
      post('initStripeIdentity', data);
    })
    .on('plenigo.googleOneTapInit', function (event, data) {
      post('googleOneTapInit', data);
    })
    .on('plenigo.googleOneTapPrompt', function (event, data) {
      post('googleOneTapPrompt', data);
    })
    .on('plenigo.initStripeButtons', function (event, data) {
      window.setTimeout(function () {
        post('checkForStripeButtons', data);
      }, 200);
    })
    .on('plenigo.showStripeButtonPayment', function (event, data) {
      post('showStripeButtonPayment', data);
      console.log('trigger showStripeButtonPayment with ', data);
    })
    .on('plenigo.loading', function () {
      body.addClass('page-loading');
      unloadFunction();
    })
    .on('plenigo.processing', function () {
      body.addClass('page-processing');
      processingFunction();
    })
    .on('plenigo.removeLoading', function () {
      body.removeClass('page-loading');
    });

  $('[data-focus]').each(function () {
    post('focusToViewport', $(this).offset().top);
  });

  $(document).on('resize plenigo.resize', function () {
    post('resize', getHeight());
  });

  body.on('plenigo.load load', function () {
    post('resize', getHeight());
  });

  if (typeof window.checkoutErrorMessage === 'string') {
    post('error', window.checkoutErrorMessage);
  }

  $('.pl-close-link a').click(function (event) {
    close();
    event.preventDefault();
  });

  $('[data-close]').click(function (event) {
    close();
    event.preventDefault();
  });

  $('[data-restart]').click(function (event) {
    window.top.location.reload();
    restart();
    event.preventDefault();
  });

  let firstError = $(':input.is-invalid:first');

  if (firstError.length) {
    post('focusToViewport', firstError.offset().top);
  }

  post('log', {
    level: 'log',
    message: 'iframe rendered',
  });

  if (body.data('error')) {
    post('sendError', body.data('error'));
  }

  window.setCookie = function (cookieName, cookieValue) {
    post('setCookie', {
      cookieName: cookieName,
      cookieValue: cookieValue,
    });
  };

  /**
   * static functionality come here
   */
  // Since Statistics is a Module, we can switch it off
  if (!hasStatistics()) {
    // return;
  }

  // Action!
  $(window).on('click', function (event) {
    if ($(event.target).is('a.pl-back-link')) {
      postAction('back', [], $(this));
    } else if ($(event.target).is('a')) {
      postAction('click', $(event.target).text(), $(event.target));
    }
  }).on('load', function () {
    postAction('load', [], $(window));
  });

  // OnBeforeLoad (Submit)
  $('form').on('submit', function () {
    var form = $(this);
    postAction('submit', [], form);
  });

}(jQuery, document, window, JSON));
